import { parseRichText } from '@utils/format';

/**
 * Finds all rich text placeholder elements within the related fabrics modal
 * and replaces their content with parsed HTML.
 */
export default class RelatedFabricsModal {
  constructor() {
    this.entries = document.querySelectorAll('.js-related-fabrics-description');
  }

  /**
   * Parses and injects rich text HTML into each description element.
   */
  init() {
    this.entries.forEach((entry) => {
      const json = entry.getAttribute('data-description');
      if (!json) return;
      entry.innerHTML = parseRichText(json);
    });
  }
}
